export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const STRONG_PASSWORD_REGEX =
  /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;

export const REGISTRATION_ID_REGEX = /^[a-zA-Z0-9]{3,50}$/;

const DIAL_CODE_REGEX = /^\+?\d{1,4}$/;

// India: 10-digit mobile numbers starting with 6-9.
export const PHONE_NUMBER_INDIA_REGEX = /^[6-9]\d{9}$/;
// Singapore: 8-digit numbers starting with 6, 8 or 9.
export const PHONE_NUMBER_SINGAPORE_REGEX = /^[689]\d{7}$/;

export function validateEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

export function isValidPhoneNumber(value: string): boolean {
  return /^\+?\d{6,15}$/.test(value.replace(/[\s\-()]/g, ""));
}

export function isValidDialCode(value: string): boolean {
  return DIAL_CODE_REGEX.test(value.trim());
}

/**
 * Validates a phone number against the country-specific rules used by the
 * profile editor (migrated from the legacy pw-cms-web app). Dial code and
 * mobile number are stored as separate fields, so only the national part is
 * validated.
 */
export function validateProfilePhone(
  dialCode: string,
  mobile: string,
): boolean {
  const digits = mobile.replace(/[^\d]/g, "");
  if (!digits) return true;
  if (dialCode === "+91") return PHONE_NUMBER_INDIA_REGEX.test(digits);
  if (dialCode === "+65") return PHONE_NUMBER_SINGAPORE_REGEX.test(digits);
  return digits.length >= 7 && digits.length <= 15;
}
